class RecentlyViewedSection {
  constructor() {
    this.section = document.querySelector(".recently-viewed");
    if (!this.section) return;

    this.container = this.section.querySelector(".recently-viewed-products");
    this.emblaWrapper = this.section.querySelector(".embla");
    this.emblaInstance = null;

    this.init();
  }

  async init() {
    const curatedAttr = this.section.dataset.curatedProducts || "";
    const handles = curatedAttr
      .split(",")
      .map((handle) => handle.trim())
      .filter(Boolean);

    if (handles.length === 0) {
      this.hideSection();
      return;
    }

    // Show a random 3 from the curated list, reshuffled on every load
    const randomHandles = this.shuffle(handles).slice(0, 3);

    await this.loadProducts(randomHandles);
  }

  shuffle(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  async loadProducts(handles) {
    try {
      // Fetch products using Section Rendering API
      const productPromises = handles.map((handle) =>
        this.fetchProduct(handle)
      );
      const products = await Promise.all(productPromises);

      // Filter out failed fetches
      const validProducts = products.filter((p) => p !== null);

      if (validProducts.length === 0) {
        this.hideSection();
        return;
      }

      // Render products
      this.renderProducts(validProducts);
      this.showSection();
      this.initCarousel();
    } catch (error) {
      console.error("Error loading recently viewed products:", error);
      this.hideSection();
    }
  }

  async fetchProduct(handle) {
    try {
      const response = await fetch(
        `/products/${handle}?section_id=product-card-recently-viewed`
      );

      if (!response.ok) {
        console.warn(`Product ${handle} not found`);
        return null;
      }

      const html = await response.text();
      return { handle, html };
    } catch (error) {
      console.error(`Error fetching product ${handle}:`, error);
      return null;
    }
  }

  renderProducts(products) {
    if (!this.container) return;

    // Clear container
    this.container.innerHTML = "";

    // Create temporary container to parse HTML
    const tempDiv = document.createElement("div");

    products.forEach(({ handle, html }) => {
      // Parse the HTML response
      tempDiv.innerHTML = html;

      // Find the product card in the response
      const productCard = tempDiv.querySelector(
        ".recently-viewed-product-card"
      );

      if (productCard) {
        this.container.appendChild(productCard);
      } else {
        // Fallback: create simple card from HTML
        const slide = document.createElement("div");
        slide.className = "embla__slide";
        slide.innerHTML = html;
        this.container.appendChild(slide);
      }
    });
  }

  initCarousel() {
    // Only initialize carousel on mobile (< 768px)
    if (window.innerWidth >= 768) return;

    if (!this.emblaWrapper || typeof EmblaCarousel === "undefined") return;

    const options = {
      loop: false,
      align: "center",
      containScroll: "trimSnaps",
      slidesToScroll: 1,
    };

    this.emblaInstance = EmblaCarousel(this.emblaWrapper, options);
  }

  showSection() {
    if (this.section) this.section.style.display = "";
  }

  hideSection() {
    if (this.section) this.section.style.display = "none";
  }

  destroy() {
    if (this.emblaInstance) {
      this.emblaInstance.destroy();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new RecentlyViewedSection();
  });
} else {
  new RecentlyViewedSection();
}
